export default __webpack_public_path__ + "static/media/04.d3cb75f9.svg";